module.exports = __webpack_public_path__ + "static/media/Logo3.fad08ad7.png";